import React from "react"

const SubmenuDivider = () => {
  return (
    <li className="topNav__subMenuItem topNav__subMenuItem-divider"/>
  )
}

export default SubmenuDivider
